$(function () {

    // const urlParams = new URLSearchParams(window.location.search)

    $('.subscribe-modal__wrapper').kendoWindow({
        size: 'auto',
        title: false,
        modal: {
            preventScroll: true
        },
        position: {
            top: '50%',
            left: '50%'
        },
        resizable: false,
    })

    $('.subscribe-modal__wrapper').data('kendoWindow').open().wrapper.addClass('subscribe-modal')
})